import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {ReportChart} from '../../../../reports/report-chart';
import type {ChartReportParams} from '../../../../reports/report-types';

import {ConnectedFormsReportProvider} from './connected-forms-report-provider';

type Props = {
    activeFilters: FilterObject[];
    onChartClick?: (filters: FilterObject) => void | null | undefined;
    onParamChange: (arg1: any, arg2: boolean) => void;
    reportParams: ChartReportParams;
    reportDataSummary?: React.ReactNode;
    hasBorder?: boolean;
    hasGap?: boolean;
    headerExtraContent?: React.ReactNode;
    height?: number;
    containerHeight?: number;
};

export function ConnectedFormsChart(props: Props) {
    return (
        <ConnectedFormsReportProvider>
            <ReportChart hasBorder={false} reportKey='formEngagement' {...props} />
        </ConnectedFormsReportProvider>
    );
}
